import type { AraGenerateRequest } from '@/features/ara-generation/api/ara-api'

export type AraStreamAdditiveFields = {
  style_guide_extra?: unknown
  section_guidance_extra?: unknown
}

/**
 * Drop additive guidance fields that master's `apps/ara` does not accept on
 * `POST /ara/stream`. Configure payloads may still carry them client-side for
 * a future re-enable; the wire body must never include them.
 */
export function stripAraStreamAdditiveFields<T extends AraStreamAdditiveFields>(
  body: T
): Omit<T, 'style_guide_extra' | 'section_guidance_extra'> {
  const {
    style_guide_extra: _styleGuideExtra,
    section_guidance_extra: _sectionGuidanceExtra,
    ...rest
  } = body
  return rest
}

export function toMasterAraStreamRequest(
  request: AraGenerateRequest
): Omit<AraGenerateRequest, 'style_guide_extra' | 'section_guidance_extra'> {
  return stripAraStreamAdditiveFields(request)
}
